import commonReducer from "./typeCommonReducer";
import requestReducer from "./typeRequestReducer";

const reducers = { common: commonReducer, requests: requestReducer };

export default reducers;
